module.exports = __webpack_public_path__ + "img/orange.2ce9087b.jpg";